<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/Bitmap.png" />
  <div class="header_text scroll-animations container-fluid">
    <div class="header_text_container position__relative d-flex flex-column">
      <h1 class="animated mb-3 jobs-title">ÚNETE A NUESTRO EQUIPO</h1>
      <div class="row sub-icons">
        <div class="col-6 col-sm-6 col-md-3">
          <img src="assets/img/Group.png" alt="" class="talent-icon" />
          <p class="talent-subtitle">flexibilidad horaria</p>
        </div>
        <div class="col-6 col-sm-6 col-md-3">
          <img src="assets/img/Group2.png" alt="" class="talent-icon" />
          <p class="talent-subtitle">trabajo en equipo</p>
        </div>
        <div class="col-6 col-sm-6 col-md-3">
          <img src="assets/img/Group3.png" alt="" class="talent-icon" />
          <p class="talent-subtitle">aprendizaje continuo</p>
        </div>
        <div class="col-6 col-sm-6 col-md-3">
          <img src="assets/img/Group4.png" alt="" class="talent-icon" />
          <p class="talent-subtitle">paquete retributivo personalizado</p>
        </div>
      </div>
    </div>
  </div>
</header>
<section>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12">
        <h2 class="mb-3 text-center">
          ¿Te apasionan los retos profesionales?
        </h2>
        <p class="text-center mb-5">
          Si eres un entusiasta del mundo digital y de las nuevas tecnologias...
          <br />
          Si quieres iniciarte en un proyecto innovador... <br />
          Si la flexibilidad y colaboración es lo tuyo... <br />
          Si deseas seguir creciendo...
        </p>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="row mt-5">
      <div class="col-12 col-md-6 d-flex flex-column align-self-center">
        <h3>Has localizado tu lugar indicado</h3>
        <p>Nos motiva trabajar con colegas responsables, entusiastas, innovadores y que no tengan MIEDO DE ASUMIR NUEVOS
          RETOS</p>
      </div>
      <div class="col-12 col-md-6">
        <img class="img_proyect" src="assets/img/pexels-fauxels-3182743.webp" alt="">
      </div>
    </div>
  </div>
</section>
<section id="" class="section-bg-clear">
  <div class="container">
    <!-- <iframe
      id="my_typeform"
      src="https://a3d8wwjymh0.typeform.com/to/v5XNGhPc"
      style="width: 100%; height: 500px"
    ></iframe> -->
    <app-jobs-form></app-jobs-form>
  </div>
</section>

<section>
  <div class="container">
    <div class="mt-5 row position__relative photos-container">
      <div class="col-12">
        <img class="img-absolute-1" src="assets/img/annie-spratt-QckxruozjRg-unsplash.png" alt="" />
        <img class="img-absolute-2" src="assets/img/helloquence-5fNmWej4tAA-unsplash.webp" alt="" />
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container mb-5 text-center">
    <div class="row">
      <div class="col-12">
        <h3>Trabaja con nosotros</h3>
        <p class="mb-3">Si no quieres perderte futuras vacantes</p>
        <br>
        <a class="btn_help" href="https://www.linkedin.com/company/zeeker-solutions/">Siguenos en Linkedin</a>
      </div>
    </div>
  </div>
</section>